import styled from 'styled-components';
import { Form } from '~/ui/components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: end;
  gap: 8px;
  align-items: center;

  button {
    min-width: 170px;
  }
`;

export const StyledForm = styled(Form)`
  margin-top: 24px;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding-bottom: 24px;

  .editor-container {
    border: 1.5px solid ${({ theme }) => theme.colors.divider.primary};
  }

  .ant-form-item-control.has-error .editor-container {
    border-color: ${({ theme }) => theme.colors.negative.primary};
  }
`;

export const TicketLoadingWrapper = styled.div`
  height: 100px;
`;

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
  padding-bottom: 24px;
`;

export const ComposeContainer = styled(StepContainer)``;

export const MessagePreview = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.element.primary};
  white-space: pre-wrap;
`;

export const MessagePreviewPlaceholder = styled.span`
  font-style: italic;
  color: ${({ theme }) => theme.colors.element.placeholder};
`;

export const ReviewContainer = styled(StepContainer)``;

export const ReviewSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider.primary};
`;

export const ReviewField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ReviewLabel = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.element.primary};
`;

export const ReviewValue = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.element.primary};
  white-space: pre-wrap;
  line-height: 1.5;
`;

export const FileItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  gap: 8px;
`;

export const FileItemLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  svg {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
  }
`;

export const FileItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const FileItemName = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.element.primary};
`;

export const FileItemSize = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.element.secondary};
`;

export const FileItemLink = styled.a`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.colors.brand.primary};
  text-decoration: none;
  font-size: 13px;
  white-space: nowrap;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
    stroke: ${({ theme }) => theme.colors.brand.primary};
  }

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.brand.primary};
  }
`;
